import { Document, Page } from 'react-pdf/dist/esm/entry.webpack5';
import { useState, useEffect, useRef } from 'react';

export default function PDFViewer({preview}) {
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(0);
  const containerRef = useRef(null);


  useEffect(() => {
    const updateWidth = () => {
      if (containerRef.current) {
        setPageWidth(containerRef.current.offsetWidth  ); 
      }
    };

    updateWidth(); // calcular al montar
    window.addEventListener('resize', updateWidth);
    return () => window.removeEventListener('resize', updateWidth);
  }, [preview]);

  return (
    <div ref={containerRef} style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
      <Document file="politica.pdf" onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
       {numPages &&
          (preview
            ? (
              <Page pageNumber={1} width={pageWidth} />
            )
            : (
              Array.from({ length: numPages }, (_, i) => (
                <Page key={i + 1} pageNumber={i + 1} width={pageWidth} />
              ))
            )
          )
        }
      </Document>
    </div>
  );
}
